import type { useRadioGroup } from '@chakra-ui/react';
import { PopoverBody, PopoverContent, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import type { SelectOption as TSelectOption } from './types';

import SelectOption from './SelectOption';

interface Props {
  options: Array<TSelectOption>;
  getRootProps: ReturnType<typeof useRadioGroup>['getRootProps'];
  getRadioProps: ReturnType<typeof useRadioGroup>['getRadioProps'];
  value: string | number;
}

const SelectContent = ({ options, getRootProps, getRadioProps, value }: Props) => {

  const root = getRootProps();
  const popoverBg = useColorModeValue('#FFFFFF', '#111111');
  const popoverBorder = useColorModeValue('#E9ECEF', '#222222');
  const popoverShadow = useColorModeValue('0 4px 16px rgba(0, 0, 0, 0.08)', '0 4px 16px rgba(0, 0, 0, 0.4)');

  return (
    <PopoverContent w="fit-content" minW="136px" bg={ popoverBg } borderColor={ popoverBorder } boxShadow={ popoverShadow }>
      <PopoverBody { ...root } py={ 2 } px={ 0 } display="flex" flexDir="column">
        { options.map((option) => {
          const radio = getRadioProps({ value: option.value });
          return (
            <SelectOption key={ option.value } { ...radio } isChecked={ radio.isChecked || (!option.value && !value) }>
              { option.label }
            </SelectOption>
          );
        }) }
      </PopoverBody>
    </PopoverContent>
  );
};

export default React.memo(SelectContent);
